(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"]) return;
  try {
    
  // Attendre que tout le contenu soit chargé
  function waitForContent(callback, maxAttempts = 20) {
    let attempts = 0;
    
    const checkContent = setInterval(() => {
      attempts++;
      const articleBody = document.getElementById('article-body-content');
      const headings = articleBody ? articleBody.querySelectorAll('h1, h2, h3, h4, h5, h6') : [];
      
      // Si on trouve des titres OU si on a atteint le max de tentatives
      if (headings.length > 0 || attempts >= maxAttempts) {
        clearInterval(checkContent);
        callback();
      }
    }, 100); // Vérifie toutes les 100ms
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      waitForContent(initTableOfContents);
    });
  } else {
    waitForContent(initTableOfContents);
  }

  function initTableOfContents() {
    const tocContainer = document.getElementById('table-of-contents');
    if (!tocContainer) {
      console.log('TOC: Container non trouvé');
      return;
    }

    const articleBody = document.getElementById('article-body-content');
    if (!articleBody) {
      console.log('TOC: Article body non trouvé');
      return;
    }

    // Scanner les blocs text avec classes h2, h3, h4, h5, h6 (exclure h1 qui est le titre principal)
    const textBlocks = articleBody.querySelectorAll('.text-block');
    const headings = [];
    
    textBlocks.forEach(block => {
      // Vérifier si le bloc a une classe h2, h3, h4, h5 ou h6
      if (block.classList.contains('h2') || 
          block.classList.contains('h3') || 
          block.classList.contains('h4') || 
          block.classList.contains('h5') || 
          block.classList.contains('h6')) {
        // Trouver le titre à l'intérieur (h1, h2, h3, etc.)
        const heading = block.querySelector('h1, h2, h3, h4, h5, h6');
        if (heading) {
          // Ajouter la classe du bloc au titre pour savoir son niveau
          heading.dataset.level = block.classList.contains('h2') ? 'h2' :
                                 block.classList.contains('h3') ? 'h3' :
                                 block.classList.contains('h4') ? 'h4' :
                                 block.classList.contains('h5') ? 'h5' : 'h6';
          headings.push(heading);
        }
      }
    });
    
    console.log('TOC: Titres trouvés:', headings.length);
    
    if (headings.length < 2) {
      console.log('TOC: Pas assez de titres (minimum 2 requis)');
      tocContainer.remove();
      return;
    }

    tocContainer.style.display = 'block';
    
    const tocNav = document.getElementById('toc-nav');
    const tocList = document.createElement('ul');
    let currentH2Li = null;
    let currentH3List = null;
    const headingElements = [];
    
    headings.forEach((heading, index) => {
      const headingId = heading.id || `toc-section-${index}`;
      heading.id = headingId;
      headingElements.push({ id: headingId, element: heading });
      
      const listItem = document.createElement('li');
      listItem.className = 'toc-item';
      
      const link = document.createElement('a');
      link.href = `#${headingId}`;
      link.textContent = heading.textContent.trim();
      link.dataset.target = headingId;
      
      link.addEventListener('click', function(e) {
        e.preventDefault();
        const target = document.getElementById(headingId);
        if (target) {
          const offset = 100;
          const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({ top: targetPosition, behavior: 'smooth' });
          
          document.querySelectorAll('.toc-nav a').forEach(a => a.classList.remove('active'));
          link.classList.add('active');
        }
      });
      
      listItem.appendChild(link);
      
      // Déterminer le niveau selon le data-level ajouté
      const level = heading.dataset.level || heading.tagName.toLowerCase();
      const isH2 = level === 'h2';
      const isH3 = level === 'h3';
      
      if (isH2) {
        tocList.appendChild(listItem);
        currentH2Li = listItem;
        currentH3List = null;
      } else if (isH3 && currentH2Li) {
        if (!currentH3List) {
          currentH3List = document.createElement('ul');
          currentH2Li.appendChild(currentH3List);
        }
        currentH3List.appendChild(listItem);
      } else {
        // Pour h4, h5, h6 ou titres non classifiés
        tocList.appendChild(listItem);
        currentH2Li = listItem;
        currentH3List = null;
      }
    });
    
    tocNav.appendChild(tocList);
    
    // Toggle functionality
    const toggleButton = tocContainer.querySelector('.toc-toggle');
    const iconOpen = toggleButton.querySelector('.toc-icon-open');
    const iconClose = toggleButton.querySelector('.toc-icon-close');
    let isCollapsed = false;
    
    toggleButton.addEventListener('click', function() {
      isCollapsed = !isCollapsed;
      tocNav.classList.toggle('collapsed', isCollapsed);
      iconOpen.style.display = isCollapsed ? 'none' : 'block';
      iconClose.style.display = isCollapsed ? 'block' : 'none';
    });
    
    // Active section highlighting on scroll
    let ticking = false;
    
    function updateActiveSection() {
      const scrollPosition = window.scrollY + 150;
      
      for (let i = headingElements.length - 1; i >= 0; i--) {
        const heading = headingElements[i];
        if (heading.element.offsetTop <= scrollPosition) {
          document.querySelectorAll('.toc-nav a').forEach(a => a.classList.remove('active'));
          const activeLink = document.querySelector(`.toc-nav a[data-target="${heading.id}"]`);
          if (activeLink) activeLink.classList.add('active');
          break;
        }
      }
      
      ticking = false;
    }
    
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(updateActiveSection);
        ticking = true;
      }
    });
    
    // Progress bar
    window.addEventListener('scroll', function() {
      const articleHeight = articleBody.offsetHeight;
      const scrolled = window.scrollY;
      const progress = Math.min((scrolled / articleHeight) * 100, 100);
      tocContainer.style.setProperty('--progress', progress + '%');
    });
    
    // Make sticky on desktop
    if (window.innerWidth > 1200) {
      tocContainer.classList.add('sticky');
    }
    
    console.log('TOC: Initialisation réussie avec', headings.length, 'titres');
  }

  } catch(e) { console.error(e); }
})();
})();
